<router-outlet></router-outlet>
<app-session-expiry-dialog></app-session-expiry-dialog>
<app-dev-permissions-panel></app-dev-permissions-panel>
